import React, { useState } from 'react'
import { CollapsibleListToggle } from '../../../legacy-design-system/list'
import { css } from '@emotion/css'

export function IpAddressCell({
  rowData: { cidrBlocks }
}: {
  readonly rowData: {
    readonly cidrBlocks: string[]
  }
}) {
  const [isExpanded, setIsExpanded] = useState(false)
  const visible = isExpanded ? cidrBlocks : cidrBlocks.slice(0, 5)
  return (
    <div>
      <ul
        className={css`
          list-style: none;
          padding: 0;
          margin: 0;
        `}
        data-testid="source-names-ip-addresses-cell"
      >
        {visible.map((cidrBlock, cidrBlockIndex) => (
          <li key={cidrBlockIndex}>{cidrBlock}</li>
        ))}
      </ul>
      {cidrBlocks.length > 5 && (
        <CollapsibleListToggle
          isExpanded={isExpanded}
          onToggle={(_isExpanded) => {
            if (isExpanded !== _isExpanded) {
              setIsExpanded(_isExpanded)
            }
          }}
        />
      )}
    </div>
  )
}
